import CURRENCIES from '@/data/currencies';

export default function currencySign(currencyISO) {
    const foundCurrency = CURRENCIES.find(
        currency => currency.iso === currencyISO,
    );
    return foundCurrency ? foundCurrency.sign : currencyISO;
}
